<template>
  <InsightsChartsTab :charts="chartConfigurations" :filters="filters" :dateRange="dateRange" :pdfMode="pdfMode"/>
</template>

<script>
import { CHART_NAMES, INSIGHTS_CHARTS } from '@/helpers/insightsCharts'

export default {
  name: 'InsightsVariationsView',

  props: {
    filters: {
      type: Array,
      required: true,
      default: () => []
    },
    dateRange: {
      type: Array,
      required: true,
      default: () => []
    },
    pdfMode: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    chartConfigurations () {
      const chartTypes = [
        CHART_NAMES.VARIATIONS_PER_STAGE,
        CHART_NAMES.VARIATIONS_PER_STATUS,
        CHART_NAMES.VARIATIONS_PER_ROOT_CAUSES,
        CHART_NAMES.VARIATIONS_TIME_IMPACT_PER_ROOT_CAUSES,
        CHART_NAMES.VARIATIONS_ACTUAL_IMPACT_IN_DAYS,
        CHART_NAMES.VARIATIONS_FINANCIAL_IMPACT_PER_ROOT_CAUSES,
        CHART_NAMES.VARIATIONS_VALUE_AND_COUNT
      ]

      return chartTypes.map(chartName => ({
        name: chartName,
        componentName: INSIGHTS_CHARTS[chartName].component,
        defaultQuery: INSIGHTS_CHARTS[chartName].defaultQuery,
        defaultTimeDimension: INSIGHTS_CHARTS[chartName].defaultTimeDimension,
        chartWidth: INSIGHTS_CHARTS[chartName].chartWidth
      }))
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }
}
</script>
